import React from 'react'

const CateringMenuIpad = () => {
    return (
        <div>CateringMenuIpad</div>
    )
}

export default CateringMenuIpad